// extracted by mini-css-extract-plugin
module.exports = {"section":"IndexPage_section__3cN3D","plug":"IndexPage_plug__3Rbsm","plug_text":"IndexPage_plug_text__1gvuY","image":"IndexPage_image__2rlx-"};